<template>
  <div class="verify_box">
    <p class="userEmail">{{$t('home.setNameTitle')}}</p>
    <div class="form_item">
      <div class="form_input psw_input">
        <input type="text"
               v-model="username"
               :placeholder="$t('toast.setNamePlaceholder')"
               class="psw">
      </div>
      <p class="setName_title">{{$t('toast.setNameTitls')}}</p>
    </div>
    <li class="form_item "
        :class="noclickFlag?'form_submit':'form_no_submit'"
        ref="form_submit"
        @click="setName">
      {{$t('toast.comfirmBtn1')}}
    </li>
  </div>
</template>

<script>
import { setUsername } from '@/api/hw'
import { appPostMessage } from '@/utils/communication'
import {
  getSessionStorage,
  getToken,
  setSessionStorage,
  removeToken,
} from '@/utils/stage'
export default {
  data() {
    return { username: '', flag: false, noclickFlag: false }
  },
  created() {
    this.init()
  },
  watch: {
    username(newVal) {
      if (newVal) {
        this.noclickFlag = true
      } else {
        this.noclickFlag = false
      }
    },
  },
  methods: {
    init() {
      this.configData = JSON.parse(getSessionStorage('message'))
    },
    nameForm() {
      //   var regex = /^(?=.*[a-zA-Zd])[!-~]{8,16}$/
      const abc = 'QWERTYUIO1'
      var regex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{7,16}/
      //   var regex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{7,16}$/
      console.log(regex.test(abc))
    },
    setName() {
      if (this.flag) {
        return
      }
      this.flag = true
      setTimeout(() => {
        this.flag = false
      }, 2000)
      if (!this.username) {
        this.$toast(this.$t('toast.setNamePlaceholder'))
        return
      }
      const access_token = JSON.parse(
        getSessionStorage('accountStorage')
      ).access_token
      const csrf_token_info = JSON.parse(getToken('csrf_token_info'))
      const data = {
        username: this.username,
        csrf_token: csrf_token_info.csrf_token,
        access_token: access_token,
      }
      const msg = Object.assign(
        JSON.parse(JSON.stringify(this.configData)),
        data
      )
      setUsername(msg).then((res) => {
        if (res.errcode == 509) {
          removeToken('csrf_token_info')
          this.$router.push({ name: 'AccountVerify', query: { id: 1 } })
          this.$toast(res.errmsg)
          return
        }
        let accountStorage = JSON.parse(getSessionStorage('accountStorage'))
        accountStorage.username = this.username
        setSessionStorage('accountStorage', JSON.stringify(accountStorage))
        this.$router.push({ path: '/success', query: { id: 5 } })
        const appmsg = { code: 2, data: accountStorage }
        appPostMessage(appmsg)
      })
    },
  },
}
</script>

<style scope lang="less">
.verify_box {
  padding: 30/75rem;
  p {
    font-size: 24/75rem;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #575757;
    margin-bottom: 20/75rem;
  }
  .userEmail {
    font-size: 28/75rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #575757;
  }
  .form_item {
    margin-top: 30/75rem;
    .setName_title {
      margin: 0 auto;
      width: 610/75rem;
      font-size: 22/75rem;
      margin-top: 10/75rem;
    }
    .form_input {
      width: 610/75rem;
      height: 80/75rem;
      border: 1px solid #575757;
      opacity: 1;
      border-radius: 6/75rem;
      padding-left: 30/75rem;
      padding-top: 21/75rem;
      box-sizing: border-box;
      margin: 0 auto;
      .setName_title {
      }
      .phone {
        border: none;
        outline: none;
        width: 100%;
        height: 34/75rem;
      }
      .psw {
        border: none;
        outline: none;
        width: 470/75rem;
        width: 100%;
      }
    }
    .psw_input {
      padding-right: 180/75rem;
      box-sizing: border-box;
      position: relative;
      .psw_btn {
        background: none;
        border: none;
        outline: none;
        position: absolute;
        display: inline-block;
        width: 180/75rem;
        right: 0;
        top: 0;
        height: 76/75rem;
        line-height: 76/75rem;
        letter-spacing: 5/75rem;
        &:before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          width: 1px;
          height: 45/75rem;
          background: #cfcfcf;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>